"use client";

import { Calendar, Mail, Laptop, Video, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "1. Rapid Response",
  description: "Our media specialists review your inquiry and respond within 24 hours to discuss your course's unique vision.",
  icon: Mail
}, {
  title: "2. Custom Proposal",
  description: "Receive a tailored quote featuring cinematic flyover options and strategic marketing graphics for your club.",
  icon: Laptop
}, {
  title: "3. Site Consultation",
  description: "We schedule a walkthrough to identify key signature holes and optimal lighting windows for aerial filming.",
  icon: Calendar
}, {
  title: "4. Production Launch",
  description: "Our FAA Part 107 pilots arrive on-site to capture high-altitude luxury visuals with minimal course disruption.",
  icon: Video
}];
export default function CommentCaFonctionne() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="259157" id="postsubmissionprocess" className="py-24 text-foreground overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-6 tracking-tight">
            Your Journey to Cinematic Excellence
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            A streamlined 4-step process designed for Arizona's premier golf courses and country clubs to elevate their digital presence.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="absolute top-12 left-[12.5%] right-[12.5%] h-1 bg-secondary/30 hidden md:block rounded-lg" aria-hidden="true"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative z-10">
            {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="w-24 h-24 rounded-2xl bg-card border-2 border-secondary/50 flex items-center justify-center mb-6 shadow-lg backdrop-blur-sm transition-transform duration-300 group-hover:-translate-y-2 group-hover:border-secondary group-hover:shadow-xl">
                  <step.icon className="w-10 h-10 text-secondary" />
                </div>
                <h3 className="text-xl font-bold font-default text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed px-2 font-default">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className="mt-20 text-center">
          <Button asChild size="lg" className="rounded-lg text-base px-8 h-14 bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
            <Link to="/RequestAQuotePage">
              Start Your Project
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}